"use strict";
/** state: Final **/
/** family: Process **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var CLASS_NAME = 'i-process__list__item';
var Components = {
    renderIcon: function (_a) {
        var finishedIcon = _a.finishedIcon;
        return (React.createElement(IconWrapper_1.IconWrapper, null,
            React.createElement(FontAwesome_1.FontAwesome, { className: CLASS_NAME + "__label--icon", name: finishedIcon })));
    },
    renderLabel: function (_a) {
        var finished = _a.finished, finishedIcon = _a.finishedIcon, label = _a.label, order = _a.order;
        return (React.createElement(React.Fragment, null,
            finished &&
                finishedIcon &&
                Components.renderIcon({ finishedIcon: finishedIcon }),
            React.createElement("span", { className: CLASS_NAME + "__label--text" }, label),
            React.createElement("span", { className: CLASS_NAME + "__label--order" }, order)));
    },
};
/**
 * The step subcomponent for a process.
 *
 * ProcessStep should only be used inside a Process.
 */
var ProcessStep = function (props) {
    var _a;
    var className = props.className, order = props.order, activeStep = props.activeStep, disableCollapse = props.disableCollapse, disableMaxWidth = props.disableMaxWidth, finishedIcon = props.finishedIcon, onClick = props.onClick, label = props.label, content = props.content, restProps = __rest(props, ["className", "order", "activeStep", "disableCollapse", "disableMaxWidth", "finishedIcon", "onClick", "label", "content"]);
    var handleClick = function (e) {
        onClick && onClick(order, e);
    };
    return (React.createElement("li", __assign({ className: classNames(className, CLASS_NAME, (_a = {},
            _a[CLASS_NAME + "--active"] = order === activeStep,
            _a[CLASS_NAME + "--finished"] = order < activeStep,
            _a[CLASS_NAME + "--clickable"] = !!onClick,
            _a[CLASS_NAME + "--disable-collapse"] = disableCollapse,
            _a[CLASS_NAME + "--disable-max-width"] = disableMaxWidth,
            _a)), onClick: handleClick }, restProps),
        React.createElement("span", { className: CLASS_NAME + "__label" }, props.order < activeStep && finishedIcon && !disableCollapse
            ? Components.renderIcon({ finishedIcon: finishedIcon })
            : content
                ? content
                : Components.renderLabel({
                    finished: props.order < activeStep,
                    /**
                     * Only using finishedIcon when disableMaxWidth is true because
                     * overflow: hidden mess up the verticalAligment between the icon
                     * and the text label
                     */
                    finishedIcon: disableMaxWidth && finishedIcon,
                    label: label,
                    order: order,
                }))));
};
exports.ProcessStep = ProcessStep;
//# sourceMappingURL=ProcessStep.js.map